<template>
  <div class="verify-2fa">
    <Loader v-if="loading" />
    <!-- <Alert type="danger" :messages="errors" /> -->
    <div
      class="d-flex flex-column align-items-center"
      style="justify-content: space-between; gap: 100px;"
    >
      <div
        class="alert d-inline-flex"
        :class="`alert-danger`"
        role="alert"
        v-if="errors.length"
      >
        <span
          v-for="(message, index) in errors"
          v-html="message"
          :key="index"
        ></span>
      </div>

      <div class="button-container" v-if="errors.length">
        <button class="btn btn-primay btn-teal">ログイン画面へ戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/utils/Alert.vue';
import FieldError from '@/components/utils/FieldError.vue';
import actions from '@/config/actions';
import { mapActions } from 'vuex';
import Api from '@/config/api';
import apiClient from '@/http';
import Loader from './utils/Loader.vue';

export default {
  name: 'Verify2FA',
  components: { FieldError, Alert, Loader },
  data() {
    return {
      message: 'Verifying your login...',
      errors: [],
      loading: true,
    };
  },
  methods: {
    ...mapActions([actions.auth.LOGGED_IN]),
  },

  mounted() {
    this.changeBodyToWhite();
    const token = this.$route.query && this.$route.query.token;
    if (!token) {
      this.errors = ['No verification token provided'];
      this.loading = false;
      return;
    }

    const self = this;
    apiClient
      .get(Api.endpoints.VERIFY_2FA, { params: { token } })
      .then(function (response) {
        const data = response.data;
        const body = data && data.data;
        const expiresIn =
          (body && body.expires_in) !== undefined
            ? body.expires_in
            : data && data.expires_in;
        self[actions.auth.LOGGED_IN]({ expires_in: expiresIn });
        self.$router.push('/applicant');
      })
      .catch(function (error) {
        const response = error.response;
        self.errors = [];
        if (response && response.status === 400) {
          return self.errors.push(
            '本人認証用リンクが無効です。再度ログイン画面よりログインを試行し、認証用リンクを新規発行してください。'
          );
        }
        if (response && response.status === 401) {
          const msg401 =
            response.data === 'Unauthorized'
              ? response.data
              : response.data &&
                response.data.data &&
                response.data.data.message
              ? response.data.data.message
              : response.data && response.data.error_description
              ? response.data.error_description
              : 'Unauthorized';
          return self.errors.push(msg401);
        }
        if (response && response.status === 402) {
          return self.errors.push(
            'アカウントがブロックされています。管理者にお問い合わせ下さい。'
          );
        }
        if (response && response.status === 403) {
          return self.errors.push('IDまたはパスワードが間違っています。');
        }
        if (response && response.status === 503) {
          const msg503 =
            (response.data && response.data.message) ||
            (response.data && response.data.error_description) ||
            'Service unavailable.';
          return self.errors.push(msg503);
        }
        self.parseErrorResponse(response);
      })
      .finally(function () {
        self.loading = false;
      });
  },
};
</script>

<style scoped>
.verify-2fa {
  text-align: center;
  padding: 50px;
}
.error {
  color: red;
}
.alert-danger {
  margin-top: 50px;
  font-size: 24px;
  border-radius: 10px;
  padding: 50px 30px;
  text-align: left;
}
.btn-teal {
  background-color: #006c6b;
  border-radius: 4px;
  color: #fff;
  padding: 15px 80px;
}
</style>
